import React from 'react';
import './Style.css';

export default function Banner({banner}){
	return (<div><img src={banner} alt={'banner'} className="banner-image"/></div>)
}
